import { FC } from 'react';
import { Field, useField } from 'formik';
import styles from './Inputs.module.scss';
import cx from 'classnames';

export interface ToggleFieldProps {
  // onChange: (value: boolean) => void;
  name: string;
  label?: string;
  disabled?: boolean;
  className?: any;
}

export const ToggleField: FC<ToggleFieldProps> = ({ label, className, ...props }) => {
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   onChange(event.target.checked);
  // };
  const [field, meta, helpers] = useField(props);
  return (
    <div
      className={cx(
        styles.toggleSwitch,
        styles.formControl,
        { [styles['toggleSwitch--disabled']]: props.disabled },
        className
      )}
    >
      {label && <span className={styles.label}>{label}</span>}
      <Field
        type='checkbox'
        disabled={props.disabled}
        className={styles.toggleSwitch__input}
        name={props.name}
        id={props.name}
        // onChange={handleChange}
      />

      <label className={styles.toggleSwitch__label} htmlFor={props.name}>
        <span className={styles.toggleSwitch__track} />
        <span className={styles.toggleSwitch__thumb} />
      </label>
    </div>
  );
};
export default ToggleField;
